const KB_SERVICE_MODES = {
  EMBEDDED: 'embedded',
  REST_API: 'rest-api',
};

const DATASOURCES = {
  ZENDESK_HELP_CENTER: 'zendeskhc',
  INTERCOM_HELP_CENTER: 'intercomhc',
  KUSTOMER_HELP_CENTER: 'kustomerhc',
  GORGIAS_HELP_CENTER: 'gorgiashc',
  SALESFORCE_HELP_CENTER: 'salesforcehc',
  SHOPIFY_HELP_CENTER: 'shopifyhc',
  CONFLUENCE: 'confluence',
  GURU_HELP_CENTER: 'guruhc',
};

// [sv2] note: this file is included in UI - using process.env.KB_SERVICE_MODE breaks the UI as there is no process in browser
const KB_SERVICE_MODE = (typeof process !== 'undefined' && process.env && process.env.KB_SERVICE_MODE) || KB_SERVICE_MODES.EMBEDDED;

const KB_DOC_VERSION = {
  CURRENT: 'current',
  DRAFT: 'draft',
};

const KB_DOC_PUBLISH_METHOD = {
  MANUAL: 'manual',
  AI_ASSISTED: 'ai',
  AUTO: 'auto',
};

const DEFAULT_EMPTY_CONTENT = 'REPLACE WITH YOUR CONTENT\n';

const DEFAULT_PUBLISHER_LLM_MODEL_NAME = 'gpt-4.1-mini';
const DEFAULT_SEMANTIC_ANALYZER_MODEL = 'gpt-4.1';

const DEFAULT_MAX_KB_SEARCH_DOCUMENTS = 4;

/**
 * Knowledge Base Service Port
 */
const KB_SERVICE_PORT = 3033;

/**
 * Knowledge Base Service Audit
 * @type {string}
 */
// TODO: consider deleting this constant
const KB_AUDIT = 'kbAudit';

const DEFAULT_CHUNK_SIZE = 1000;
const DEFAULT_CHUNK_OVERLAP = 200;

export {
  KB_SERVICE_PORT,
  KB_SERVICE_MODES,
  KB_SERVICE_MODE,
  DATASOURCES,
  KB_DOC_VERSION,
  KB_DOC_PUBLISH_METHOD,
  DEFAULT_EMPTY_CONTENT,
  DEFAULT_PUBLISHER_LLM_MODEL_NAME,
  DEFAULT_MAX_KB_SEARCH_DOCUMENTS,
  KB_AUDIT,
  DEFAULT_SEMANTIC_ANALYZER_MODEL,
  DEFAULT_CHUNK_SIZE,
  DEFAULT_CHUNK_OVERLAP,
};
